import instance from "@/utils/require.js"

// 物料管理--分页查询
export function apiItemCodeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/search",
		method: "post",
		data
	})
}
// 物料使用记录（UUID）--分页查询
export function apiUuidRecordSearch(data = {}) {
	return instance({
		url: "aim/api/v3/uuid/store_record/search",
		method: "post",
		data
	})
}

export function apiExportUuidRecord(data = {}) {
	return instance({
		url: "aim/api/v3/uuid/store_record/export_uuidRecord",
		method: "post",
		data
	})
}

// 物料管理--新增
export function apiItemCodeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/add",
		method: "post",
		data
	})
}

// 物料管理--修改
export function apiItemCodeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/update",
		method: "post",
		data
	})
}


// -修改邮件通知
export function apiItemCodeUpdateEmailNotice(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/updateEmailNotice",
		method: "post",
		data
	})
}
// 物料管理--编码类型下拉
export function apiItemCodeType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/item_code_type",
		method: "post",
		data
	})
}

// 物料管理--产品类别下拉
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 物料管理--产品型号列表
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 联想物料编码--分页查询
export function apiLenovoMaterialSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/search",
		method: "post",
		data
	})
}

// 联想物料编码--新增
export function apiLenovoMaterialAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/add",
		method: "post",
		data
	})
}

// 联想物料编码--修改
export function apiLenovoMaterialUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/update",
		method: "post",
		data
	})
}

// 联想物料编码--复制
export function apiLenovoMaterialCopy(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/copy",
		method: "post",
		data
	})
}

// 联想物料编码--删除
export function apiLenovoMaterialDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/delete",
		method: "post",
		data
	})
}

// 联想物料编码--导入
export function apiLenovoMaterialImport(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/import",
		method: "post",
		data
	})
}

// 联想物料编码--导出
export function apiLenovoMaterialExport(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_material/export",
		method: "post",
		data
	})
}

// 联想配件编码--分页查询
export function apiLenovoPartCodeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_part_code/search",
		method: "post",
		data
	})
}

// 联想配件编码--新增
export function apiLenovoPartCodeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_part_code/add",
		method: "post",
		data
	})
}

// 联想配件编码--修改
export function apiLenovoPartCodeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_part_code/update",
		method: "post",
		data
	})
}

// 联想配件编码--删除
export function apiLenovoPartCodeDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_part_code/delete",
		method: "post",
		data
	})
}

// 联想配件编码--导入
export function apiLenovoPartCodeImport(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_part_code/import",
		method: "post",
		data
	})
}

// 联想配件编码--导出
export function apiLenovoPartCodeExport(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo_part_code/export",
		method: "post",
		data
	})
}